import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=52e0ca1c&"
import script from "./NewHeader.vue?vue&type=script&lang=js&"
export * from "./NewHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewHeader.vue?vue&type=style&index=0&id=52e0ca1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default,CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default})
